import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMixpanelEvent } from "../utils/mixpanel";

const getTrackedAncestor = (element: HTMLElement | null): HTMLElement | null => {
  let el = element;
  while (el && el !== document.body) {
    if (
      el.tagName === "BUTTON" ||
      el.tagName === "A" ||
      el.getAttribute("role") === "button" ||
      el.dataset.mixpanelTrack !== undefined
    ) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
};

const MixpanelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackMixpanelEvent("Page View", {
      path: location.pathname,
      search: location.search,
      title: document.title,
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = getTrackedAncestor(event.target as HTMLElement);
      if (!target) return;

      trackMixpanelEvent("Element Click", {
        path: window.location.pathname,
        tag: target.tagName.toLowerCase(),
        text: target.textContent?.trim().slice(0, 100) || "",
        id: target.id || undefined,
        class_name: target.className || undefined,
        href: target instanceof HTMLAnchorElement ? target.href : undefined,
      });
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
};

export default MixpanelTracker;
